import { Component, OnInit,EventEmitter,Output,Input } from '@angular/core';

@Component({
  selector: 'app-card-item-list',
  templateUrl: './card-item-list.component.html',
  styleUrls: ['./card-item-list.component.scss']
})
export class CardItemListComponent implements OnInit {
  @Input() items: { [key: string]: any }[] = [];
  @Input() ListHeader;
  @Output() onItemClicked = new EventEmitter<cardClickOutput>();
  constructor() { }

  ngOnInit(): void {
  }
  onClickItem(id: number,index) {
    this.onItemClicked.emit({id,index});
  }
}
export interface cardClickOutput{
  id:number,index:number
}